'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keeper = require('../keeper');

var _keeper2 = _interopRequireDefault(_keeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Promise = window.Promise || require('promise');
var KNB = window.KNB;

var App = function () {
    function App() {
        _classCallCheck(this, App);

        this.type = 'app'; // 收归`dianping`、`meituan`，CAT中请用容器区分
        this.GEOTYPE = ['wgs84', 'gcj02'];
        this.keeper = undefined;
    }

    _createClass(App, [{
        key: 'process',
        value: function process(succ, fail, next) {
            var _this = this;

            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            // 预处理
            typeof succ == 'function' || (succ = this.noop);
            typeof fail == 'function' || (fail = this.noop);
            typeof next == 'function' || (next = this.noop);

            if (!this.supportGeo()) return next();
            opt.trigger = function (token) {
                fail({
                    // code: 408, // 说明：定位超时放弃兜底方案，与API超时结果处理一致
                    message: _this.type + ' API Timeout:' + opt.timeout + 'ms',
                    type: _this.type
                }, token);
            };
            this.keeper = new _keeper2.default(opt);

            Promise.resolve(KNB || this.initSDK()).then(function () {
                KNB.ready(function () {
                    var KNBP = KNB.getPromiseInstance();
                    KNBP.isApiSupported({
                        apiName: 'getLocation'
                    }).then(function (isSupported) {
                        if (isSupported) {
                            return KNBP.getLocation({
                                timeout: opt.timeout / 1000,
                                cache: false
                            });
                        } else {
                            fail({
                                code: 412, // API不支持走兜底方案
                                type: _this.type
                            }, _this.keeper.getToken());
                        }
                    }, function () {
                        fail({
                            code: 412, // API不支持走兜底方案
                            type: _this.type
                        }, _this.keeper.getToken());
                    }).then(function (ret) {
                        ret && succ({
                            lat: ret.lat,
                            lng: ret.lng,
                            geoType: _this._parseGeoType(ret.type),
                            type: _this.type
                        }, _this.keeper.getToken());
                    }, function () {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        /**
                         * JSB API结果：未授权(-100)、API超时(-101)、定位错误
                         * SDK策略覆盖GPS WIFI 基站等（不包含IP），成功率高于补位API，后者可能会有奇怪的授权弹框
                         */
                        fail({
                            message: e.errorMsg || 'app geo error',
                            type: _this.type
                        }, _this.keeper.getToken());
                    }).catch(function (e) {
                        // 异常
                        fail({
                            code: 400,
                            message: e && e.message || JSON.stringify(e),
                            type: _this.type
                        }, _this.keeper.getToken());
                    });
                });
            });
        }
    }, {
        key: 'initSDK',
        value: function initSDK() {
            return new Promise(function (resolve) {
                require.ensure([], function () {
                    KNB = require('@dp/knb/bundle');
                    resolve();
                }, 'whereami-knb');
            });
        }
    }, {
        key: 'supportGeo',
        value: function supportGeo() {
            return this._inDPAPP() || this._inMTAPP();
        }
    }, {
        key: '_inDPAPP',
        value: function _inDPAPP() {
            return (/dp\/com\.dianping/.test(navigator.userAgent)
            );
        }
    }, {
        key: '_inMTAPP',
        value: function _inMTAPP() {
            return (/meituan/.test(navigator.userAgent)
            );
        }
    }, {
        key: '_parseGeoType',
        value: function _parseGeoType(type) {
            if (type && isNaN(type) && ~this.GEOTYPE.indexOf(type.toLowerCase())) {
                // string
                return type.toLowerCase();
            } else if (parseInt(type) || parseInt(type) === 0) {
                // number
                return this.GEOTYPE[parseInt(type)];
            }
            // default
            return this.GEOTYPE[this._inMTAPP() ? 1 : 0];
        }
    }]);

    return App;
}();

var instance = new App();
module.exports = instance.process.bind(instance);
module.exports.type = instance.type;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/geos/app.js
// module id = 527
// module chunks = 1 12 14